import { render } from "./DashboardVideoCard.vue?vue&type=template&id=3ce13a65&scoped=true"
import script from "./DashboardVideoCard.vue?vue&type=script&lang=js"
export * from "./DashboardVideoCard.vue?vue&type=script&lang=js"

import "./DashboardVideoCard.vue?vue&type=style&index=0&id=3ce13a65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce13a65"]])

export default __exports__